import { configureStore } from "@reduxjs/toolkit";
import { objectStorageActions } from "modules/objectStorage/slices";
import createSagaMiddleware from "redux-saga";
import { rootReducer } from "./reducers";
import { rootSaga } from "./sagas";

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
      serializableCheck: {
        /*
         * Upload actions carry a File and AWS SDK endpoint/region providers.
         * The saga consumes them directly, nothing lands in the store.
         */
        ignoredActions: [
          objectStorageActions.uploadFileRequest.type,
          objectStorageActions.uploadFileFailure.type
        ]
      }
    }).concat(sagaMiddleware)
});

sagaMiddleware.run(rootSaga);
